<template>
  <div class="relative mt-4">
    <new-table-lite
      class="admin-table summary Totals"
      :is-loading="table.isLoading"
      :is-static-mode="true"
      :is-slot-mode="true"
      :columns="columnDay"
      :rows="table.rows"
      :total="table.totalRecordCount"
      :sortable="table.sortable"
      @is-finished="table.isLoading = false"
      :page-size="table.pagesize"
      :pageOptions="table.pageOptions"
      :has-checkbox="false"
      :is-hide-paging="false"
      :pageSizeChangeLabel="'pageSizeChangeLabel'"
      :messages="tableMessages"
    >
      <template v-slot:filter>
        <tr class="vtl-thead-tr z-20">
          <td class="vtl-tbody-td">
            <span>Totals</span>
          </td>
          <td class="vtl-tbody-td"></td>
          <td class="vtl-tbody-td">{{ sumPayload.numOfOrders }}</td>
          <td class="vtl-tbody-td">{{ sumPayload.numOfRefOrders }}</td>
          <td class="vtl-tbody-td">{{ sumPayload.netSoldOrders }}</td>
          <td class="vtl-tbody-td">{{ displayPriceFormat(sumPayload.totalInvoice) }}</td>
          <td class="vtl-tbody-td">{{ displayPriceFormat(sumPayload.grossSales) }}</td>
          <td class="vtl-tbody-td">{{ displayPriceFormat(sumPayload.netSales) }}</td>
          <td class="vtl-tbody-td">{{ displayPriceFormat(sumPayload.totalDiscount) }}</td>
          <td class="vtl-tbody-td">{{ displayPriceFormat(sumPayload.totalOtherDiscount) }}</td>
          <td class="vtl-tbody-td">{{ displayPriceFormat(sumPayload.totalPromotionDiscount) }}</td>
          <td class="vtl-tbody-td">{{ displayPriceFormat(sumPayload.totalPromoCodeDiscount) }}</td>
          <td class="vtl-tbody-td"></td>
          <td class="vtl-tbody-td">{{ sumPayload.totalLoyalityRedemption }}</td>
          <td class="vtl-tbody-td">{{ sumPayload.rewardRedemption }}</td>
          <td class="vtl-tbody-td">{{ displayPriceFormat(sumPayload.totalRefundAmount) }}</td>
          <td class="vtl-tbody-td">{{ sumPayload.totalTax }}</td>
          <td class="vtl-tbody-td">{{ displayPriceFormat(sumPayload.totalFees) }}</td>
          <td class="vtl-tbody-td">{{ displayPriceFormat(sumPayload.totalTips) }}</td>
          <td class="vtl-tbody-td">{{ displayPriceFormat(sumPayload.totalCost) }}</td>
          <td class="vtl-tbody-td">{{ displayPriceFormat(sumPayload.grossProfit) }}</td>
          <td class="vtl-tbody-td">{{ displayPriceFormat(sumPayload.grossProfit/sumPayload.netSales*100) }}</td>
          <td class="vtl-tbody-td">{{ sumPayload.totalProductSold }}</td>
          <td class="vtl-tbody-td">{{ sumPayload.numOfLoyalityRedeem }}</td>
          <td class="vtl-tbody-td"></td>
          <td class="vtl-tbody-td"></td>
          <td class="vtl-tbody-td"></td>
          <td class="vtl-tbody-td">{{ displayPriceFormat(sumPayload.cashPayment) }}</td>
          <td class="vtl-tbody-td">{{ displayPriceFormat(sumPayload.amex) }}</td>
          <td class="vtl-tbody-td">{{ displayPriceFormat(sumPayload.master) }}</td>
          <td class="vtl-tbody-td">{{ displayPriceFormat(sumPayload.vis) }}</td>
          <td class="vtl-tbody-td">{{ displayPriceFormat(sumPayload.debit) }}</td>
          <td class="vtl-tbody-td">{{ displayPriceFormat(sumPayload.uber) }}</td>
          <td class="vtl-tbody-td">{{ displayPriceFormat(sumPayload.gift_card) }}</td>
          <td class="vtl-tbody-td">{{ displayPriceFormat(sumPayload.other) }}</td>
          <td class="vtl-tbody-td">{{ displayPriceFormat(sumPayload.onlineSales) }}</td>
          <td class="vtl-tbody-td">{{ displayPriceFormat(sumPayload.instoreSales) }}</td>
        </tr>
      </template>

      <template v-slot:date="data">
        <span v-if="data.value.date">{{ readableDate(data.value.date) }}</span>
      </template>
      <template v-slot:totalInvoice="data">
        <span>{{ displayPriceFormat(data.value.totalInvoice) }}</span>
      </template>
      <template v-slot:grossSales="data">
        <span>{{ displayPriceFormat(data.value.grossSales) }}</span>
      </template>
      <template v-slot:netSales="data">
        <span>{{ displayPriceFormat(data.value.netSales) }}</span>
      </template>
      <template v-slot:totalDiscount="data">
        <span>{{ displayPriceFormat(data.value.totalDiscount) }}</span>
      </template>
      <template v-slot:totalOtherDiscount="data">
        <span>{{ displayPriceFormat(data.value.totalOtherDiscount) }}</span>
      </template>
      <template v-slot:totalPromotionDiscount="data">
        <span>{{ displayPriceFormat(data.value.totalPromotionDiscount) }}</span>
      </template>
      <template v-slot:totalPromoCodeDiscount="data">
        <span>{{ displayPriceFormat(data.value.totalPromoCodeDiscount) }}</span>
      </template>
      <template v-slot:totalRefundAmount="data">
        <span>{{ displayPriceFormat(data.value.totalRefundAmount) }}</span>
      </template>
      <template v-slot:totalTax="data">
        <span>{{ displayPriceFormat(data.value.totalTax) }}</span>
      </template>
      <template v-slot:totalFees="data">
        <span>{{ displayPriceFormat(data.value.totalFees) }}</span>
      </template>
      <template v-slot:totalTips="data">
        <span>{{ displayPriceFormat(data.value.totalTips) }}</span>
      </template>
      <template v-slot:totalCost="data">
        <span>{{ displayPriceFormat(data.value.totalCost) }}</span>
      </template>
      <template v-slot:grossProfit="data">
        <span>{{ displayPriceFormat(data.value.grossProfit) }}</span>
      </template>
      <template v-slot:grossMargin="data">
        <span>{{ displayPriceFormat(data.value.grossMargin) }}</span>
      </template>
      <template v-slot:cashPayment="data">
        <span>{{ displayPriceFormat(data.value.cashPayment) }}</span>
      </template>
      <template v-slot:amex="data">
        <span>{{ displayPriceFormat(data.value.cardPayments.amex) }}</span>
      </template>
      <template v-slot:master="data">
        <span>{{ displayPriceFormat(data.value.cardPayments.master) }}</span>
      </template>
      <template v-slot:vis="data">
        <span>{{ displayPriceFormat(data.value.cardPayments.visa) }}</span>
      </template>
      <template v-slot:debit="data">
        <span>{{ displayPriceFormat(data.value.cardPayments.debit) }}</span>
      </template>
      <template v-slot:uber="data">
        <span>{{ displayPriceFormat(data.value.cardPayments.uber) }}</span>
      </template>
      <template v-slot:gift_card="data">
        <span>{{ data.value.cardPayments.gift_card }}</span>
      </template>
      <template v-slot:other="data">
        <span>{{ displayPriceFormat(data.value.cardPayments.other) }}</span>
      </template>
      <template v-slot:onlineSales="data">
        <span>{{ displayPriceFormat(data.value.onlineSales) }}</span>
      </template>
      <template v-slot:instoreSales="data">
        <span>{{ displayPriceFormat(data.value.instoreSales) }}</span>
      </template>
    </new-table-lite>
  </div>
</template>

<script>
import { defineComponent, ref } from 'vue'
import Env from '@/env'
import StringHelpers from '@/helpers/string'
import moment from 'moment-timezone'
import NewTableLite from '@/components/table/tableLite.vue'

const tableMessages = {
  pagingInfo: 'Total: {2}',
  pageSizeChangeLabel: 'Items per Page',
  gotoPageLabel: '',
  noDataAvailable: 'No records found!',
}

export default defineComponent({
  components: {
    NewTableLite,
  },
  props: {
    payload: {
      type: Array,
      required: false,
      default: () => [],
    },
    sumPayload: {
      type: Object,
      required: false,
      default: () => ({}),
    },
  },
  setup() {
    const columnDay = [
      {
        isKey: true,
        label: 'Date',
        field: 'date',
        sortable: false,
        headerClasses: 'width',
      },
      {
        label: 'Location',
        field: 'locationName',
        sortable: false,
        headerClasses: 'width',
      },
      {
        label: 'Orders Sold',
        field: 'numOfOrders',
        sortable: false,
      },
      {
        label: 'Orders Refunded',
        field: 'numOfRefOrders',
        sortable: false,
      },
      {
        label: 'Net Orders Sold',
        field: 'netSoldOrders',
        sortable: false,
      },
      {
        label: 'Total Receipts',
        field: 'totalInvoice',
        sortable: false,
      },
      {
        label: 'Gross Sales',
        field: 'grossSales',
        sortable: false,
      },
      {
        label: 'Net Sales',
        field: 'netSales',
        sortable: false,
      },
      {
        label: 'Total Discount',
        field: 'totalDiscount',
        sortable: false,
      },
      {
        label: 'Total Other Discounts',
        field: 'totalOtherDiscount',
        sortable: false,
      },
      {
        label: 'Total Promotion Discounts',
        field: 'totalPromotionDiscount',
        sortable: false,
      },
      {
        label: 'Total Promo Code Discounts',
        field: 'totalPromoCodeDiscount',
        sortable: false,
      },
      {
        label: 'Discount Markdown %',
        field: 'discountMarkdown',
        sortable: false,
      },
      {
        label: 'Total Membership Redemptions',
        field: 'totalLoyalityRedemption',
        sortable: false,
      },
      {
        label: 'Reward Tiers',
        field: 'rewardRedemption',
        sortable: false,
      },
      {
        label: 'Refunds in $',
        field: 'totalRefundAmount',
        sortable: false,
      },
      {
        label: 'Total Tax',
        field: 'totalTax',
        sortable: false,
      },
      {
        label: 'Total Fees',
        field: 'totalFees',
        sortable: false,
      },
      {
        label: 'Total Tips',
        field: 'totalTips',
        sortable: false,
      },
      {
        label: 'Cost of Goods Sold',
        field: 'totalCost',
        sortable: false,
      },
      {
        label: 'Gross Profit',
        field: 'grossProfit',
        sortable: false,
      },
      {
        label: 'Gross Margin',
        field: 'grossMargin',
        sortable: false,
      },
      {
        label: 'Items Sold',
        field: 'totalProductSold',
        sortable: false,
      },
      {
        label: '# of Membership Redemptions',
        field: 'numOfLoyalityRedeem',
        sortable: false,
      },
      {
        label: 'Avg Items Sold Per Order',
        field: 'avgItemPerTrans',
        sortable: false,
      },
      {
        label: 'Avg item qty per Order',
        field: 'avgItemQtyPerTrans',
        sortable: false,
      },
      {
        label: 'Avg Order $',
        field: 'avgTransaction',
        sortable: false,
      },
      {
        label: 'Cash',
        field: 'cashPayment',
        sortable: false,
      },
      {
        label: 'Amex',
        field: 'amex',
        sortable: false,
      },
      {
        label: 'Mastercard',
        field: 'master',
        sortable: false,
      },
      {
        label: 'Visa',
        field: 'vis',
        sortable: false,
      },
      {
        label: 'Debit',
        field: 'debit',
        sortable: false,
      },
      {
        label: 'Uber',
        field: 'uber',
        sortable: false,
      },
      {
        label: 'Gift card',
        field: 'gift_card',
        sortable: false,
      },
      {
        label: 'Other',
        field: 'other',
        sortable: false,
      },
      {
        label: 'Online sales $',
        field: 'onlineSales',
        sortable: false,
      },
      {
        label: 'In-store sales $',
        field: 'instoreSales',
        sortable: false,
      },
    ]
    const table = ref({
      isLoading: false,
      rows: [],
      totalRecordCount: 0,
      sortable: {
        order: 'name',
        sort: 'asc',
      },
      pagesize: Env.defaultPageSize,
      pageOptions: Env.pageList,
      count: 0,
      page: 1,
    })

    return {
      table,
      columnDay,
      tableMessages,
    }
  },
  mounted() {
    this.load()
    this.emitter.on('reloadSalesList', this.reload)
  },
  beforeDestroy() {
    this.emitter.off('reloadSalesList', this.reload)
  },
  methods: {
    displayPriceFormat(price) {
      return StringHelpers.roundOff(price, 2)
    },
    reload() {
      this.$nextTick(() => {
        this.load()
      })
    },
    load() {
      this.table.rows = this.payload
      this.table.totalRecordCount = this.payload.length
      this.table.isLoading = false
    },
    readableDate(data) {
      if (!data) return
      return moment(data).format('YYYY-MM-DD')
    },
  },
})
</script>
